<template>
  <v-dialog v-model="dialogDettaglioDocumento" fullscreen hide-overlay transition="dialog-bottom-transition">
    <v-card>
      <v-toolbar dark :color="colorModalita" dense>
        <v-btn icon dark @click="closeDialogDocumento">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>{{dialogTitle}}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn dark text @click="closeDialogDocumento">
            Chiudi
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>     
      <header-documento :locDocumento="locDocumento" :filtraTipiDocumento="filtraTipiDocumento" :headerReadOnly="readOnly" :trigger="trigger" :mostraParcheggio="mostraParcheggio"  :forzaTipo="forzaTipo" @aggiornaDocumento="aggiornaDocumento" ref="headerDocumento"/> <!-- @update-tipo-documento="updateTipoDocumento" -->
      <body-documento :locDocumento="locDocumento" :trigger="trigger" :readOnly="readOnly" @nuovaRiga="onNuovaRiga" @updateTotali="trigger++" @mostraParcheggio="onMostraParcheggio" @move="spostaRiga" ref="bodyDocumento"/>
      <footer-documento :locDocumento="locDocumento" :trigger="trigger" :readOnly="readOnly" @updateTotali="triggerLocale++" @daSalvare="daSalvare = true" ref="footerDocumento"/>
      <v-alert v-model="datiNonCompleti" dismissible prominent dense type="error">Non sono stati inseriti tutti i dati necessari</v-alert>
      <v-card-actions>
        <v-container>
          <v-row align="center" justify="end">
            <v-btn v-if="abilitaSenzaPrezzi" color="blue-grey lighten-1" class="mt-3 mr-5" @click="stampaDocumentoNoPrezzi">Stampa senza prezzi</v-btn>
            <v-btn color="info" class="mt-3 mr-5" @click="stampaDocumento">Stampa documento</v-btn>
            <v-btn color="primary" class="mt-3 mr-5" :disabled="salvataggioInCorso || saveDisabled" @click="salvaDocumento">Salva documento</v-btn>
            <!-- <v-btn color="success" v-if="hasXml" class="mt-3 mr-5" :disabled="saveDisabled" @click="salvaXML">Salva e crea XML</v-btn> -->
        </v-row>
        </v-container>
      </v-card-actions>
    </v-card>
    <v-dialog v-model="dialogCloseConfirm" max-width="500px">
      <v-card>
        <v-card-title class="text-h5">Confermi chiusura senza salvataggio ?</v-card-title>
        <v-card-text>Il documento potrebbe non essere stato salvato</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closeConfirm">SI</v-btn>
          <v-btn color="blue darken-1" text @click="cancelClose">NO</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-dialog>
</template>

<script>
  import moment from 'moment'
  import { downloadXml, getAnnoRiferimento } from '@/components/helpers.js'
  import errorService from '@/services/errorService'
  import { printed } from '@/helpers/printed.js'
  import xml7 from '@/services/xml7Service.js'
  import HeaderDocumento from './header.vue'
  import BodyDocumento from './bodyTable.vue'
  import FooterDocumento from './footer.vue'
  import documenti from '@/services/documentiService.js'
  import movimenti from '@/services/movimentiService.js'
  import magazzino from '@/services/magazzinoService.js'
  import configurazioni from '@/services/configurazioniService.js'
  import reporting from '@/services/reportingService.js'

  export default {
    components: {
      HeaderDocumento,
      BodyDocumento,
      FooterDocumento
    },
    props: {
      showDialog: { type: Boolean, default: false },
      idDocumento: { type: String, default: '' },
      nuovoDocumento: Boolean,
      readOnly: Boolean,
      filtraTipiDocumento: Array,
      coloreOrdine: Boolean,
      forzaDocumento: String
    },
    data () {
      return {
        locDocumento: { model: '', generale: '', source: '' },
        dialogDettaglioDocumento: false,
        trigger: 1,
        triggerLocale: 1,
        daSalvare: false,
        mostraParcheggio: false,
        statoNullo: { codice: '', descrizione: '' },
        dialogCloseConfirm: false,
        forzaTipo: null,
        datiNonCompleti: false,
        salvataggioInCorso: false
      }
    },
    beforeMount() {
      window.addEventListener("beforeunload", this.preventNav)
    },
    beforeDestroy() {
      window.removeEventListener("beforeunload", this.preventNav);
    },
    async mounted() {
      if (this.idDocumento) {
        this.locDocumento = await documenti.getDocumento(this.idDocumento)
        this.completaAppoggio()
      } else {
        this.locDocumento = await documenti.getModello('xxx')
        this.completaAppoggio()
        this.locDocumento.data = new Date()
      }
      this.dialogDettaglioDocumento = this.showDialog
    },
    watch: {
      async showDialog(value) {
        if (value) {
          await this.refresh()
          setTimeout(async () => {
            if (this.forzaDocumento) {
              const tipi = await configurazioni.getConfigurazione('documenti_parametri', 'tipiDocumento')
              const tipoDocumento = tipi.find(x => x.tipoDocumento === this.forzaDocumento)
              this.forzaTipo = tipoDocumento
            }
          } , 300) 
        }
      },
      trigger() {
        this.daSalvare = true
      }
    },
    computed: {    
      dialogTitle() {
        // TODO: Specificare in base al tipo scelto
        return this.idDocumento ? `Documento nr. ${this.idDocumento} ${this.readOnly ? ' (sola lettura)' : ''}` : 'Nuovo documento'
      },
      isOrdineOrPreventivoCliente() {
        const dd = this.trigger && this.locDocumento
        if (dd && _.get(this.locDocumento,'tipoDocumento.tipoDocumento', '')) {
          return ['preventivoCliente', 'ordineCliente'].includes(this.locDocumento.tipoDocumento.tipoDocumento)
        }
        return false
      },
      abilitaSenzaPrezzi() {
        const dd = this.trigger && this.locDocumento
        if (dd && _.get(this.locDocumento,'tipoDocumento.tipoDocumento', '')) {
          return ['ddt', 'trasferimento'].includes(this.locDocumento.tipoDocumento.tipoDocumento)
        }
        return false
      },
      colorModalita() {
        if (this.coloreOrdine || this.isOrdineOrPreventivoCliente) {
          return this.nuovoDocumento ? 'amber' : 'amber darken-4'
        } else {
          return this.nuovoDocumento ? 'success' : 'primary'
        }
      },
      saveDisabled() {
        if (this.readOnly) return true
        return this.trigger && this.triggerLocale && this.locDocumento && this.locDocumento.totali && this.locDocumento.totali.generale ? (this.locDocumento.totali.generale.quantita === 0 || !this.daSalvare) : true
      },
      hasXml() {
        return this.trigger && this.triggerLocale && _.get(this.locDocumento, 'tipoDocumento.xml', false)
      }
    },
    methods: {
      preventNav(event) {
        if (!this.dialogDettaglioDocumento) return
        event.preventDefault()
        event.returnValue = ""
      },      
      onMostraParcheggio(value) {
        this.mostraParcheggio = value
      },      
      spostaRiga(da, a) {
        let righe = this.locDocumento.righe
        let daSpostare = JSON.parse(JSON.stringify(righe[da]))
        righe.splice(da, 1)
        // righe = _.pullAt(righe, da)
        if (a === -1) {
          righe.push(daSpostare)
        } else {
          righe.splice(a, 0, daSpostare)
        }
        this.trigger++
      },
      async onNuovaRiga(riga) {
        this.locDocumento.righe.push(riga)
        this.trigger++
      },
      async refresh() {
        if (this.idDocumento) {
          this.locDocumento = await documenti.getDocumento(this.idDocumento)
          this.completaAppoggio()
        } else {
          this.locDocumento = await documenti.getModello('xxx')
          this.completaAppoggio()
          this.locDocumento.data = new Date()
        }
        this.dialogDettaglioDocumento = true
        this.trigger++
      },
      completaAppoggio() {
        let itm = this.locDocumento
        _.set(itm,'appoggio.clienteVisibile', itm.tipoDocumento && itm.tipoDocumento.visualizzaCliente)
        _.set(itm,'appoggio.fornitoreVisibile', itm.tipoDocumento && itm.tipoDocumento.visualizzaFornitore)
        _.set(itm,'appoggio.spedizioneVisibile', itm.tipoDocumento && itm.tipoDocumento.infoSpedizione)
        _.set(itm,'appoggio.pagamentoVisibile', itm.tipoDocumento && itm.tipoDocumento.infoPagamento)
        _.set(itm,'appoggio.tipoDocumento', itm.tipoDocumento)
        const clifor = _.get(itm, 'anagrafica.cliente', '') || _.get(itm, 'anagrafica.fornitore', '')
        _.set(itm,'appoggio.clifor', clifor)
        for (let r of itm.righe) {
          _.set(r, 'appoggio.rigaDescrittiva', r.rigaDescrittiva)
        }
      },
      async aggiornaDocumento(documento) {
        Object.assign(this.locDocumento, documento)
        this.completaAppoggio()
        this.trigger++
      },
      async generaXmlItem(itemId) {
        const documento = await documenti.getDocumento(itemId)
        if (documento) {
          const { fattura, nomeFile, xml7File } = await xml7.creaXml7Fattura(documento)
          downloadXml(document, nomeFile, xml7File)
        }
      },
      async stampaDocumentoNoPrezzi() {
        let item = this.locDocumento
        try {
          const result = await reporting.stampaDocumento(this.$router, item, true, true, true)
          if (result && result.error) {
            errorService.onError(JSON.stringify(result.error))
          } else {
            await printed(item._id)
          }
        } catch {}
      },
      async stampaDocumento() {
        let item = this.locDocumento
        try {
          const result = await reporting.stampaDocumento(this.$router, item, true, true)
          if (result && result.error) {
            errorService.onError(JSON.stringify(result.error))
          } else {
            await printed(item._id)
          }
        } catch {}
      },
      async salvaDocumento() {
        // TODO: Verificare corretta compilazione di tutti i campi required + tipo pagamento se fatture
        this.salvataggioInCorso = true
        await this.$nextTick()
        const bodyDocumento = this.$refs.bodyDocumento
        const headerDocumento = this.$refs.headerDocumento
        const footerDocumento = this.$refs.footerDocumento
        let datiOk = bodyDocumento.datiCompleti()
        datiOk = datiOk && headerDocumento.datiCompleti()
        datiOk = datiOk && footerDocumento.datiCompleti()
        this.datiNonCompleti = !datiOk
        if (!datiOk) {
          this.salvataggioInCorso = false
          return
        }
        try {
          let itm = this.locDocumento
          errorService.onInfo(JSON.stringify(itm))
          if (!itm.tipoDocumento.codice) {
            alert('Tipo documento non corretto! Contattare l\'assistenza')
            this.salvataggioInCorso = false
            return
          }
          var result
          if (!itm._id) {
            const numeratore = itm.tipoDocumento.numeratore
            const annoRiferimento = getAnnoRiferimento(itm.data) // itm.data.getFullYear()
            const numero = await configurazioni.getNumeratore(numeratore, true, annoRiferimento)
            itm._id = numero
            itm.codice = numero
            result = await documenti.creaDocumento(itm)      
            await this.verificaAggiungiMovimenti(result)
          } else {
            if (_.get(itm, 'stato.codice', '') === 'daVerificare') {
              itm.stato = this.statoNullo
            }
            result = await documenti.aggiornaDocumento(itm)
            await this.verificaModificaMovimenti(result)
          }

          // FIXME: workaround per continuare a leggere la giacenza del prodotto. Verificare completamente. Problemi anche se cambiano le righe
          for (let i = 0; i < result.righe.length; i++) {
            if (itm.righe[i]) {
              result.righe[i].appoggio = itm.righe[i].appoggio
            } else {
              result.righe[i].appoggio = {}
            }
          }

          this.locDocumento = result
          this.completaAppoggio()
          this.trigger++
          this.$emit('salvataggioAvvenuto', this.locDocumento)
          await this.$nextTick()
          this.daSalvare = false
          this.salvataggioInCorso = false
          return result
        } catch (error) {
          errorService.onError(error, 'editDocumento.salvaDocumento')
          this.salvataggioInCorso = false
        }
      },
      async salvaXML() {
        if (this.daSalvare || !this.locDocumento._id) {
          await this.salvaDocumento()
        }
        await this.generaXmlItem(this.locDocumento._id)
      },
      closeDialogDocumento() {
        if (!this.saveDisabled) {
          this.dialogCloseConfirm = true
        } else {
          this.closeDialog()
        }
      },
      closeConfirm() {
        this.dialogCloseConfirm = false
        this.closeDialog()
      },
      cancelClose() {
        this.dialogCloseConfirm = false
      },
      closeDialog() {
        this.locDocumento = { model: '', generale: '', source: '', tipoDocumento: { codice: null } }
        this.dialogDettaglioDocumento = false
        this.$emit('refresh')
      },
      async verificaAggiungiMovimenti(documento) {
        // Verificare altri tipi di documento
        console.log(documento.tipoDocumento.tipoDocumento)
        if (!['fatturaImmediata', 'ddt', 'trasferimento'].includes(documento.tipoDocumento.tipoDocumento)) return
        
        const prodotti = documento.righe.filter(x => x.prodotto && x.prodotto.codice)
        const modello = await movimenti.getModello('xxx')
        let numErrori = 0
        let baseId = moment(documento.data || new Date()) // + String(Math.round(Math.random() * 10000))
        for (const p of prodotti) {
          if (p.scalaTaglie) {
            for (const pp of p.scalaTaglie.elencoProdotti) {
              let movimento = JSON.parse(JSON.stringify(modello))       
                movimento.data = documento.data || new Date()
                movimento._id = baseId.format('YYYYMMDDHHmmssSSS') + String(Math.round(Math.random() * 10000))
                baseId = baseId.add(1, 'milliseconds')                
                movimento.magazzino = documento.magazzino
                movimento.prodotto = {
                  codice: pp.id, // p.prodotto.codice,
                  lotti: [],
                  um: p.unitaMisura,
                  quantita: +parseFloat(pp.quantita).toFixed(2),
                  prezzoAcquisto: _.get(p, 'appoggio.prodotto.acquisto', 0),
                  prezzoUnitario: _.get(p, 'valore.listino.ivato', true) ? _.get(p, 'valore.prezzoUnitario', 0) : _.get(p, 'valore.prezzoNettoUnitario', 0),
                  listino: _.get(p, 'valore.listino', null)
                }
                movimento.quantita = +parseFloat(pp.quantita).toFixed(2)
                let vv = _.get(p, 'valore.listino.ivato', true) ? +parseFloat(p.valore.importoTotale).toFixed(2) : +parseFloat(p.valore.importoNettoTotale).toFixed(2) 
                movimento.valore = +((vv / p.quantita) * pp.quantita).toFixed(2)
                movimento.causale = documento.tipoDocumento.causale
                movimento.anagrafica = {
                  cliente: documento.anagrafica.cliente,
                  fornitore: ''
                }
                movimento.riferimento = {
                  tipo: 'documento',
                  id: documento.codice,
                  data: documento.data
                }
                if (!await magazzino.creaMovimenti(movimento)) {
                  numErrori++
                }
                if (documento.tipoDocumento.secondoMagazzino) {
                  movimento._id = baseId.format('YYYYMMDDHHmmssSSS') + String(Math.round(Math.random() * 10000))
                  baseId = baseId.add(1, 'milliseconds')                  
                  movimento.causale = documento.tipoDocumento.causale2
                  movimento.magazzino = documento.magazzino2
                  if (!await magazzino.creaMovimenti(movimento)) {
                    numErrori++
                  }            
                }
            }
          } else {
          let movimento = JSON.parse(JSON.stringify(modello))
            // TODO: Nel caso di modifica andrebbe aggiunto un secondo ad ogni riga, altrimenti la data è identica su tutte le righe. 
            //       C'è rnd finale, ma con tante righe è possible che ne generi due uguali          
            movimento.data = documento.data || new Date()
            movimento._id = baseId.format('YYYYMMDDHHmmssSSS') + String(Math.round(Math.random() * 10000))
            baseId = baseId.add(1, 'milliseconds')
            movimento.magazzino = documento.magazzino
            movimento.prodotto = {
              codice: p.prodotto.codice,
              lotti: [],
              um: p.unitaMisura,
              quantita: +parseFloat(p.quantita).toFixed(2),
              prezzoAcquisto: _.get(p, 'appoggio.prodotto.acquisto', 0),
              prezzoUnitario: _.get(p, 'valore.listino.ivato', true) ? _.get(p, 'valore.prezzoUnitario', 0) : _.get(p, 'valore.prezzoNettoUnitario', 0),
              listino: _.get(p, 'valore.listino', null)
            }
            movimento.quantita = +parseFloat(p.quantita).toFixed(2)
            movimento.valore = _.get(p, 'valore.listino.ivato', true) ? +parseFloat(p.valore.importoTotale).toFixed(2) : +parseFloat(p.valore.importoNettoTotale).toFixed(2) 
            movimento.causale = documento.tipoDocumento.causale
            movimento.anagrafica = {
              cliente: documento.anagrafica.cliente,
              fornitore: ''
            }
            movimento.riferimento = {
              tipo: 'documento',
              id: documento.codice,
              data: documento.data
            }
            if (!await magazzino.creaMovimenti(movimento)) {
              numErrori++
            }
            if (documento.tipoDocumento.secondoMagazzino) {
              movimento._id = baseId.format('YYYYMMDDHHmmssSSS') + String(Math.round(Math.random() * 10000))
              baseId = baseId.add(1, 'milliseconds')              
              movimento.causale = documento.tipoDocumento.causale2
              movimento.magazzino = documento.magazzino2
              if (!await magazzino.creaMovimenti(movimento)) {
                numErrori++
              }            
            }
          } 

 /*  */
        }

      },
      async verificaModificaMovimenti(documento) {
        if (!_.get(documento, 'tipoDocumento.codice')) {
          errorService.onInfo('verificaModificaMovimenti: Errore tipoDocumento nullo :' + JSON.stringify(documento))
          return
        }
        if (!['fatturaImmediata', 'ddt', 'trasferimento'].includes(documento.tipoDocumento.tipoDocumento)) return
        await magazzino.cancellaPerRiferimento('documento', documento.codice, documento.data)
        await this.verificaAggiungiMovimenti(documento)
      },
      async creaMovimentoSingolo(modello, documento, p) {
        let movimento = JSON.parse(JSON.stringify(modello))
        // TODO: Nel caso di modifica andrebbe aggiunto un secondo ad ogni riga, altrimenti la data è identica su tutte le righe. 
        //       C'è rnd finale, ma con tante righe è possible che ne generi due uguali          
        movimento.data = documento.data || new Date()
        movimento.magazzino = documento.magazzino
        movimento.prodotto = {
          codice: p.prodotto.codice,
          lotti: [],
          um: p.unitaMisura,
          quantita: +parseFloat(p.quantita).toFixed(2),
          prezzoAcquisto: _.get(p, 'appoggio.prodotto.acquisto', 0),
          prezzoUnitario: _.get(p, 'valore.listino.ivato', true) ? _.get(p, 'valore.prezzoUnitario', 0) : _.get(p, 'valore.prezzoNettoUnitario', 0),
          listino: _.get(p, 'valore.listino', null)
        }
        movimento.quantita = +parseFloat(p.quantita).toFixed(2)
        movimento.valore = _.get(p, 'valore.listino.ivato', true) ? +parseFloat(p.valore.importoTotale).toFixed(2) : +parseFloat(p.valore.importoNettoTotale).toFixed(2) 
        movimento.causale = documento.tipoDocumento.causale
        movimento.anagrafica = {
          cliente: documento.anagrafica.cliente,
          fornitore: ''
        }
        movimento.riferimento = {
          tipo: 'documento',
          id: documento.codice,
          data: documento.data
        }
        if (!await magazzino.creaMovimenti(movimento)) {
          numErrori++
        }
        if (documento.tipoDocumento.secondoMagazzino) {
          movimento.causale = documento.tipoDocumento.causale2
          movimento.magazzino = documento.magazzino2
          if (!await magazzino.creaMovimenti(movimento)) {
            numErrori++
          }            
        }
      }
    }
  }
</script>
